import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortDesc = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3333 2.66675V10.6667H15.3333L12.6667 14.0001L10 10.6667H12V2.66675H13.3333ZM8 12.0001V13.3334H2V12.0001H8ZM9.33333 7.33341V8.66675H2V7.33341H9.33333ZM9.33333 2.66675V4.00008H2V2.66675H9.33333Z",
		fill: "#616778"
	})
});
export default SvgSortDesc;
